import { render, staticRenderFns } from "./DesignProviderDropdown.vue?vue&type=template&id=5e0d0397&"
import script from "./DesignProviderDropdown.vue?vue&type=script&lang=ts&"
export * from "./DesignProviderDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports